import React from "react";

import CartInformation from '../CartInformation';


function Checkout({ item, DadosAPI }) {
 

    return (
      <>
        <CartInformation DadosAPI={DadosAPI}/>
      </>
    );
}

export default Checkout;
